module.exports = __webpack_public_path__ + "resources/img/img_spiceware_pii_anp_02_kor.44d6dc1cf44a471d2ee2b46dcb668c47.png";